export const UPDATE_COMMENT_REQUEST = 'comment/UPDATE_REQUEST';
export const UPDATE_COMMENT_SUCCESS = 'comment/UPDATE_SUCCESS';
export const UPDATE_COMMENT_FAILURE = 'comment/UPDATE_FAILURE';
